<div *ngIf="isConnected; else offline" class="connection-status">
  <nb-icon icon="wifi"></nb-icon> <span class="label">آنلاین</span>
  <span class="online"></span>
</div>

<ng-template #offline>
  <div class="connection-status">
    <nb-icon icon="wifi-off"></nb-icon> <span class="label">عدم اتصال</span>
    <span class="offline"></span>
  </div>
</ng-template>
